export default {
  OPTICS: 'OPTICS',
  MLA: 'MLA',
  IEEE: 'IEEE',
  APA: 'APA',
  RESUME: 'RESUME',
  COVER_LETTER: 'COVER LETTER',
};
